import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';


const PrivacyPolicyPage = () => {
    const navigate = useNavigate();
    const [navbarOpen, setNavbarOpen] = useState(false); // State for the navbar toggle

    // Scroll to the top of the page when the component is loaded
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const handleHome = () => {
        navigate('/');
    };
    return (
        <>

            <div className="flex flex-col bg-white py-10 px-10 2xl:px-96 xl:px-96 md:px-24">
                <div className="flex gap-5 mt-6 me-4 mb-16 my-auto" >
                    <button className="focus:border-blue-900 justify-center px-12 py-2 text-lg font-medium text-white bg-blue-900 rounded max-lg:px-5 max-lg:mx-1 me-2" onClick={handleHome}>
                        <i className="fa fa-arrow-left ml-2" style={{ color: '#ffffff' }}></i> {" "}Back to Home
                    </button>
                </div>
                <div className="flex flex-col w-full max-md:mt-10 max-md:max-w-full">
                    <div className="text-3xl font-semibold">
                        Privacy Policy
                    </div>
                    <div className="flex flex-col mt-2 w-full  max-md:mt-10 max-md:max-w-full">
                        <div className="mt-4 text-lg max-md:max-w-full text-neutral-900">
                            The Smart Chokidar App is committed to protecting the privacy of individuals. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you access or use the Service. By using the Service, you agree to the terms of this Privacy Policy.
                        </div>
                    </div>
                    <div className="text-3xl font-semibold text-blue-900 mt-12">
                        <span className="text-neutral-900">1. Information We </span>Collect
                    </div>
                    <div className="text-lg mt-4 text-neutral-900 max-md:max-w-full">
                        We may collect the following types of information:
                    </div>
                    <div className="flex flex-col grid 2xl:grid-cols-1 md:grid-cols-1 sm:grid-cols-1 mt-6 w-full max-md:max-w-full gap-5">
                        <div className="flex flex-col gap-3 px-6 py-5 w-full bg-gray-100 rounded-xl border border-gray-200 border-solid max-md:px-5 max-md:max-w-full">
                            <div className="text-xl font-bold text-neutral-900">
                                <span className="text-blue-900">A)</span>&nbsp; Personal Information
                            </div>
                            <div className='flex flex-row items-start gap-2 '>
                                <i className="fa fa-circle-o mybzb_text_clr text-xs pt-1" ></i>
                                <div className=" w-full text-base text-zinc-600 max-md:max-w-full">
                                    Name
                                </div>
                            </div>
                            <div className='flex flex-row items-start gap-2 '>
                                <i className="fa fa-circle-o mybzb_text_clr text-xs pt-1" ></i>
                                <div className=" w-full text-base text-zinc-600 max-md:max-w-full">
                                    Contact details (e.g., email address, phone number)
                                </div>
                            </div>
                            <div className='flex flex-row items-start gap-2 '>
                                <i className="fa fa-circle-o mybzb_text_clr text-xs pt-1" ></i>
                                <div className=" w-full text-base text-zinc-600 max-md:max-w-full">
                                    Residential address
                                </div>
                            </div>
                            <div className='flex flex-row items-start gap-2 '>
                                <i className="fa fa-circle-o mybzb_text_clr text-xs pt-1" ></i>
                                <div className=" w-full text-base text-zinc-600 max-md:max-w-full">
                                    Payment information (e.g., bank account details, transaction history)
                                </div>
                            </div>
                        </div>
                        <div className="flex flex-col gap-3 px-6 py-5 w-full bg-gray-100 rounded-xl border border-gray-200 border-solid max-md:px-5 max-md:max-w-full">
                            <div className="text-xl font-bold text-neutral-900">
                                <span className="text-blue-900">B)</span>&nbsp; Non-Personal Information
                            </div>
                            <div className='flex flex-row items-start gap-2 '>
                                <i className="fa fa-circle-o mybzb_text_clr text-xs pt-1" ></i>
                                <div className=" w-full text-base text-zinc-600 max-md:max-w-full">
                                    Device details (e.g., IP address, browser type, operating system)
                                </div>
                            </div>
                            <div className='flex flex-row items-start gap-2 '>
                                <i className="fa fa-circle-o mybzb_text_clr text-xs pt-1" ></i>
                                <div className=" w-full text-base text-zinc-600 max-md:max-w-full">
                                    Usage data (e.g., pages viewed, time spent on the Service)
                                </div>
                            </div>
                            <div className='flex flex-row items-start gap-2 '>
                                <i className="fa fa-circle-o mybzb_text_clr text-xs pt-1" ></i>
                                <div className=" w-full text-base text-zinc-600 max-md:max-w-full">
                                    Cookies and tracking data
                                </div>
                            </div>
                        </div>
                        <div className="flex flex-col gap-3 px-6 py-5 w-full bg-gray-100 rounded-xl border border-gray-200 border-solid max-md:px-5 max-md:max-w-full">
                            <div className="text-xl font-bold text-neutral-900">
                                <span className="text-blue-900">C)</span>&nbsp; Other Information
                            </div>
                            <div className='flex flex-row items-start gap-2 '>
                                <i className="fa fa-circle-o mybzb_text_clr text-xs pt-1" ></i>
                                <div className=" w-full text-base text-zinc-600 max-md:max-w-full">
                                    Information submitted by users, such as service requests, feedback, or complaints.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="text-3xl font-semibold text-blue-900 mt-12">
                    <span className="text-neutral-900">2. How We Use Your </span>Information
                </div>
                <div className="text-lg mt-4 text-neutral-900 max-md:max-w-full">
                    We use the information we collect for the following purposes:
                </div>
                <div className="flex flex-col grid 2xl:grid-cols-1 md:grid-cols-1 sm:grid-cols-1 mt-6 w-full max-md:max-w-full gap-5">
                    <div className="flex flex-col gap-3 px-6 py-5 w-full bg-gray-100 rounded-xl border border-gray-200 border-solid max-md:px-5 max-md:max-w-full">
                        <div className='flex flex-row items-start gap-2 '>
                            <i className="fa fa-circle-o mybzb_text_clr text-xs pt-1" ></i>
                            <div className=" w-full text-base text-zinc-600 max-md:max-w-full">
                                To provide, operate, and maintain the Service.
                            </div>
                        </div>
                        <div className='flex flex-row items-start gap-2 '>
                            <i className="fa fa-circle-o mybzb_text_clr text-xs pt-1" ></i>
                            <div className=" w-full text-base text-zinc-600 max-md:max-w-full">
                                To process payments and manage financial records.
                            </div>
                        </div>
                        <div className='flex flex-row items-start gap-2 '>
                            <i className="fa fa-circle-o mybzb_text_clr text-xs pt-1" ></i>
                            <div className=" w-full text-base text-zinc-600 max-md:max-w-full">
                                To communicate with you, including sending updates, notifications, or promotional messages.
                            </div>
                        </div>
                        <div className='flex flex-row items-start gap-2 '>
                            <i className="fa fa-circle-o mybzb_text_clr text-xs pt-1" ></i>
                            <div className=" w-full text-base text-zinc-600 max-md:max-w-full">
                                To improve user experience and enhance the Service.
                            </div>
                        </div>
                        <div className='flex flex-row items-start gap-2 '>
                            <i className="fa fa-circle-o mybzb_text_clr text-xs pt-1" ></i>
                            <div className=" w-full text-base text-zinc-600 max-md:max-w-full">
                                To comply with legal and regulatory obligations
                            </div>
                        </div>
                    </div>
                </div>

                <div className="text-3xl font-semibold text-blue-900 mt-12">
                    <span className="text-neutral-900">3. How We Share Your </span>Information
                </div>
                <div className="text-lg mt-4 text-neutral-900 max-md:max-w-full">
                    We may share your information with third parties under the following circumstances:
                </div>
                <div className="flex flex-col grid 2xl:grid-cols-1 md:grid-cols-1 sm:grid-cols-1 mt-6 w-full max-md:max-w-full gap-5">
                    <div className="flex flex-col gap-3 px-6 py-5 w-full bg-gray-100 rounded-xl border border-gray-200 border-solid max-md:px-5 max-md:max-w-full">
                        <div className="text-xl font-bold text-neutral-900">
                            <span className="text-blue-900">A)</span>&nbsp; Service Providers:
                        </div>
                        <div className='flex flex-row items-start gap-2 '>
                            <i className="fa fa-circle-o mybzb_text_clr text-xs pt-1" ></i>
                            <div className=" w-full text-base text-zinc-600 max-md:max-w-full">
                                With trusted vendors who perform services on our behalf (e.g., payment processing, IT support).
                            </div>
                        </div>
                    </div>
                    <div className="flex flex-col gap-3 px-6 py-5 w-full bg-gray-100 rounded-xl border border-gray-200 border-solid max-md:px-5 max-md:max-w-full">
                        <div className="text-xl font-bold text-neutral-900">
                            <span className="text-blue-900">B)</span>&nbsp; Legal Compliance:
                        </div>
                        <div className='flex flex-row items-start gap-2 '>
                            <i className="fa fa-circle-o mybzb_text_clr text-xs pt-1" ></i>
                            <div className=" w-full text-base text-zinc-600 max-md:max-w-full">
                                To comply with legal obligations or in response to lawful requests by public authorities.
                            </div>
                        </div>
                    </div>
                    <div className="flex flex-col gap-3 px-6 py-5 w-full bg-gray-100 rounded-xl border border-gray-200 border-solid max-md:px-5 max-md:max-w-full">
                        <div className="text-xl font-bold text-neutral-900">
                            <span className="text-blue-900">C)</span>&nbsp;  Business Transfers:
                        </div>
                        <div className='flex flex-row items-start gap-2 '>
                            <i className="fa fa-circle-o mybzb_text_clr text-xs pt-1" ></i>
                            <div className=" w-full text-base text-zinc-600 max-md:max-w-full">
                                In connection with a merger, sale, or transfer of assets, where user information is part of the assets transferred.
                            </div>
                        </div>
                    </div>
                    <div className="flex flex-col gap-3 px-6 py-5 w-full bg-gray-100 rounded-xl border border-gray-200 border-solid max-md:px-5 max-md:max-w-full">
                        <div className="text-xl font-bold text-neutral-900">
                            <span className="text-blue-900">D)</span>&nbsp; Consent:
                        </div>
                        <div className='flex flex-row items-start gap-2 '>
                            <i className="fa fa-circle-o mybzb_text_clr text-xs pt-1" ></i>
                            <div className=" w-full text-base text-zinc-600 max-md:max-w-full">
                                With your consent or as directed by you.
                            </div>
                        </div>
                    </div>
                </div>
                <div className="text-lg mt-4 text-neutral-900 max-md:max-w-full">
                    We do not sell your personal information to third parties.
                </div>

                <div className="text-3xl font-semibold text-blue-900 mt-12">
                    <span className="text-neutral-900">4. Data </span>Security
                </div>
                <div className="text-lg mt-4 text-neutral-900 max-md:max-w-full">
                    We implement reasonable technical, administrative, and physical safeguards to protect your information. However, no method of data transmission or storage is completely secure, and we cannot guarantee absolute security.
                </div>


                <div className="text-3xl font-semibold text-blue-900 mt-12">
                    <span className="text-neutral-900">5. Your </span>Rights
                </div>
                <div className="text-lg mt-4 text-neutral-900 max-md:max-w-full">
                    Depending on your location, you may have the following rights:
                </div>
                <div className="flex flex-col grid 2xl:grid-cols-1 md:grid-cols-1 sm:grid-cols-1 mt-6 w-full max-md:max-w-full gap-5">
                    <div className="flex flex-col gap-3 px-6 py-5 w-full bg-gray-100 rounded-xl border border-gray-200 border-solid max-md:px-5 max-md:max-w-full">
                        <div className='flex flex-row items-start gap-2 '>
                            <i className="fa fa-circle-o mybzb_text_clr text-xs pt-1" ></i>
                            <div className=" w-full text-base text-zinc-600 max-md:max-w-full">
                                The right to access, update, or delete your personal information.
                            </div>
                        </div>
                        <div className='flex flex-row items-start gap-2 '>
                            <i className="fa fa-circle-o mybzb_text_clr text-xs pt-1" ></i>
                            <div className=" w-full text-base text-zinc-600 max-md:max-w-full">
                                The right to object to the processing of your information.
                            </div>
                        </div>
                        <div className='flex flex-row items-start gap-2 '>
                            <i className="fa fa-circle-o mybzb_text_clr text-xs pt-1" ></i>
                            <div className=" w-full text-base text-zinc-600 max-md:max-w-full">
                                The right to data portability.
                            </div>
                        </div>
                        <div className='flex flex-row items-start gap-2 '>
                            <i className="fa fa-circle-o mybzb_text_clr text-xs pt-1" ></i>
                            <div className=" w-full text-base text-zinc-600 max-md:max-w-full">
                                The right to withdraw consent, where processing is based on consent.
                            </div>
                        </div>
                    </div>
                </div>
                <div className="text-lg mt-4 text-neutral-900 max-md:max-w-full">
                    To exercise these rights, please contact us at <span className='font-bold'>info@headway.org.in</span>
                </div>

                <div className="text-3xl font-semibold text-blue-900 mt-12">
                    <span className="text-neutral-900">6. Retention of </span>Information
                </div>
                <div className="text-lg mt-4 text-neutral-900 max-md:max-w-full">
                    We retain your personal information only for as long as necessary to fulfill the purposes outlined in this Privacy Policy or as required by law.
                </div>

                <div className="text-3xl font-semibold text-blue-900 mt-12">
                    <span className="text-neutral-900">7. Third-Party </span>Services
                </div>
                <div className="text-lg mt-4 text-neutral-900 max-md:max-w-full">
                    The Service may include links to third-party websites or services. We are not responsible for the privacy practices or content of these third-party sites.
                </div>

                <div className="text-3xl font-semibold text-blue-900 mt-12">
                    <span className="text-neutral-900">8. Children's </span>Privacy
                </div>
                <div className="text-lg mt-4 text-neutral-900 max-md:max-w-full">
                    The Service is not intended for individuals under the age of 18. We do not knowingly collect personal information from children.
                </div>

                <div className="text-3xl font-semibold text-blue-900 mt-12">
                    <span className="text-neutral-900">9. Policy </span>Updates
                </div>
                <div className="text-lg mt-4 text-neutral-900 max-md:max-w-full">
                    We may update this Privacy Policy from time to time. The "Effective Date" at the top of this page indicates when this Privacy Policy was last revised. Your continued use of the Service after any changes constitutes your acceptance of the revised Privacy Policy.
                </div>

                <div className="text-3xl font-semibold text-blue-900 mt-12">
                    <span className="text-neutral-900">10. Contact </span>Us
                </div>
                <div className="text-lg mt-4 text-neutral-900 max-md:max-w-full">
                    If you have any questions or concerns about this Privacy Policy or our practices, please contact us at:
                </div>

                <div className="text-lg mt-8 font-semibold text-neutral-900 max-md:max-w-full">
                    Headway Business Solutions LLP
                </div>
                <div className="text-lg font-semibold text-neutral-900 max-md:max-w-full">
                    101, Kashi Parekh Complex, B/H Bhagwati Chamber, C G Road, Ahmedabad
                </div>
                <div className="text-lg font-semibold text-neutral-900 max-md:max-w-full">
                    Email : info@headway.org.in
                </div>
                <div className="text-lg font-semibold text-neutral-900 max-md:max-w-full">
                    Contact : +91 90812 41916
                </div>


                <div className="flex gap-5 mt-6 me-4 mb-16 my-auto" >
                    <button className="focus:border-blue-900 justify-center px-12 py-2 text-lg font-medium text-white bg-blue-900 rounded max-lg:px-5 max-lg:mx-1 me-2" onClick={handleHome}>
                        <i className="fa fa-arrow-left ml-2" style={{ color: '#ffffff' }}></i> {" "}Back to Home
                    </button>
                </div>
            </div>
        </>
    )
}

export default PrivacyPolicyPage